import React from 'react';
import { Button, ButtonToolbar, Card, CardBody, Col } from 'reactstrap';
import SkillTable from './SkillTable';
import { useSkillUIContext } from '../SkillUIProvider';

const SkillTableWrapper = () => {
  const skillUIContext = useSkillUIContext();

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className="products-list">
          <div className="card__title">
            <h5 className="bold-text">Skills List</h5>
            <ButtonToolbar className="products-list__btn-toolbar-top">
              <Button color="primary" onClick={skillUIContext.openNewSkillDialog}>
                Add new Skills
              </Button>
            </ButtonToolbar>
          </div>
          <SkillTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SkillTableWrapper;
